import React, { useState, createContext } from 'react';

export const OTPContext = createContext();

export const OTPProvider = ({ children }) => {
  const [confirmResult, setConfirmResult] = useState(null);
  return <OTPContext.Provider value={[confirmResult, setConfirmResult]}>{children}</OTPContext.Provider>;
};
